const myProfile = {  

    // FollowersList
  followers: {
  title: "Personen, die dir folgen",
  search: {
    placeholder: "Follower suchen…",
    ariaLabel: "Follower suchen",
  },
  states: {
    loading: "Wird geladen…",
    noMatches: "Keine Treffer.",
    noFollowers: "Noch keine Follower.",
  },
  row: {
    followedYou: "Folgt dir seit:",
    noDate: "—",
  },
  buttons: {
    view: "Anzeigen",
    moreActions: "Weitere Aktionen",
  },
  dropdown: {
    block: "Blockieren",
    blockAndReport: "Blockieren & melden",
  },
  block: {
    displayNameFallback: "diesem Benutzer",
    confirm:
      "{{displayName}} blockieren? Diese Person kann nicht mehr mit dir interagieren und ihr könnt die Beiträge oder Nachrichten des jeweils anderen nicht mehr sehen.",
    success: "Benutzer wurde blockiert.",
    failed: "Blockieren fehlgeschlagen",
  },
},

////////////////////////////////////////////////////////////
//FollowingList
////////////////////////////////////////////////////////////

followingList: {
  title: "Personen, denen du folgst",
  searchPlaceholder: "Profile durchsuchen…",
  searchAria: "Profile durchsuchen",
  loading: "Wird geladen…",
  emptyNoQuery: "Du folgst noch niemandem.",
  emptyWithQuery: "Keine Treffer.",
  followedOn: "Gefolgt seit: {{date}}",
  followedOnUnknown: "Gefolgt seit: —",
  viewProfile: "Anzeigen",

  blockConfirm:
    "{{name}} blockieren? Diese Person kann nicht mehr mit dir interagieren und ihr könnt die Beiträge oder Nachrichten des jeweils anderen nicht mehr sehen.",
  blockUnnamedUser: "diesem Benutzer",
  blockSuccess: "Benutzer wurde blockiert.",
  blockFailedFallback: "Blockieren fehlgeschlagen",
  moreActions: "Weitere Aktionen",
  block: "Blockieren",
  blockAndReport: "Blockieren & melden",
},

////////////////////////////////////////////////////////////
//FollowingFeed
////////////////////////////////////////////////////////////

followingFeed: {
  loading: "Beiträge deiner abonnierten Benutzer werden geladen…",
  noPosts: "Noch keine Beiträge von Personen, denen du folgst",
  unknownUser: "Unbekannt",
},

////////////////////////////////////////////////////////////
//GalleryPostEditing
////////////////////////////////////////////////////////////

galleryPostEditing: {
  title: "Galeriebeitrag bearbeiten",

  loading: "Wird geladen...",
  noMedia: "Keine Medien in diesem Beitrag.",

  buttons: {
    saving: "Wird gespeichert…",
    saveChanges: "Änderungen speichern",
    cancelEdit: "Bearbeitung abbrechen",
  },

  success: {
    updated: "✅ Beitrag aktualisiert!",
  },

  errors: {
    invalidUrl: "❌ Ungültige Beitrags-URL.",
    notMedia: "⚠️ Dieser Editor unterstützt nur Medienbeiträge.",
    notOwner: "⚠️ Du bist nicht berechtigt, diesen Beitrag zu bearbeiten.",
    loadFailed: "❌ Beitrag konnte nicht geladen werden.",
    notLoaded: "Beitrag wurde noch nicht geladen.",
    save401: "❌ Speichern fehlgeschlagen (401). Bitte melde dich erneut an.",
    saveGeneric: "❌ Speichern fehlgeschlagen. {{message}}",
  },
},

////////////////////////////////////////////////////////////
//MyLikes and Modals
////////////////////////////////////////////////////////////

MyLikes: {
  loading: "Deine gelikten Beiträge werden geladen…",
  empty: "Du hast noch keine Beiträge gelikt.",
  buttons: {
    chat: "Chat",
  },
  media: {
    previewAlt: "Vorschau",
    unknownTrack: "Titel",
    openDetails: "Details zu {{title}} öffnen",
    openUnknownDetails: "Titeldetails öffnen",
  },
  post: {
    unknownUser: "Unbekannter Benutzer",
    noMedia: "Keine Medien verfügbar",
    likedAt: "Gelikt am {{date}}",
    presentationButton: "Präsentation",
    likeButton: "❤️ Gefällt mir ({{count}})",
    unlikeButton: "💔 Gefällt mir nicht mehr ({{count}})",
  },
},

likes: {
  modalTitle: "❤️ Gefällt mir von",
},

likeListModal: {
  title: "Gefällt mir",

  actions: {
    close: "Schließen",
  },

  search: {
    placeholder: "Nach Profilnamen suchen…",
    ariaLabel: "Personen nach Profilnamen durchsuchen",
  },

  loading: "Likes werden geladen…",

  empty: {
    title: "Noch keine Likes.",
    subtitle: "Sobald jemand diesen Beitrag mit „Gefällt mir“ markiert, erscheint die Person hier.",
  },

  noMatches: {
    title: "Keine Treffer",
    subtitle: "Versuche einen anderen Namen.",
  },

  unknownUser: "Unbekannter Benutzer",
},

////////////////////////////////////////////////////////////
//MyPostings
////////////////////////////////////////////////////////////

myPosts: {
  media: {
    remove: "Medium entfernen",
    openDetails: "Details zu {{title}} öffnen",
    openUnknownDetails: "Titeldetails öffnen",
  },

  meta: {
    created: "{{datetime}} • {{type}}",
    location: "• 📍 {{city}}, {{country}}",
    likes: "• ❤️ {{count}} Likes",
    showLikesTooltip: "Anzeigen, wem dieser Beitrag gefällt",
    noMediaToOpen: "Keine Medien zum Öffnen",
    openViewer: "Viewer öffnen",
    presentation: "Präsentation",
  },

  actions: {
    edit: "Beitrag bearbeiten",
    delete: "Beitrag löschen",
    confirmDelete: "Diesen Beitrag löschen? Dieser Vorgang kann nicht rückgängig gemacht werden. Der Beitrag und alle Medien werden dauerhaft entfernt.",
    hide: "Beitrag ausblenden",
    unhide: "Beitrag einblenden",
    hideTooltip: "Beitrag ausblenden",
    unhideTooltip: "Beitrag einblenden",
    saving: "Wird gespeichert…",
  },

  errors: {
    hideFailed: "Beitrag konnte nicht ausgeblendet werden.",
    unhideFailed: "Beitrag konnte nicht eingeblendet werden.",
  },

  loading: "Meine Beiträge werden geladen...",
},

////////////////////////////////////////////////////////////
//Notifications
////////////////////////////////////////////////////////////

notifications: {
  open: "Benachrichtigungen öffnen",
  loading: "Benachrichtigungen werden geladen...",

  delete: {
    confirm: "Möchtest du diese Benachrichtigung wirklich löschen?",
    tooltip: "Benachrichtigung löschen",
    deleting: "Wird gelöscht..."
  },

  common: {
    someone: "Jemand",
  },

  filters: {
    all: "Alle",
    messages: "Nachrichten",
    likes: "Likes",
    follow: "Follower",
  },

  empty: {
    all: "🔔 Noch keine Benachrichtigungen",
    chat: "💬 Noch keine Nachrichten",
    like: "🖼 Noch keine Likes",
    follow: "👤 Noch keine neuen Follower",
  },

  like: {
    liked: "gefällt",
    yourPost: "dein Beitrag",
    fromDate: "vom {{date}}",
    unknownDate: "von einem unbekannten Datum",
  },

  follow: {
    started: "folgt dir jetzt",
  },

  chat: {
    sentYouA: "hat dir gesendet:",
    openChat: "Chat öffnen",
    newMessage: "Neue Nachricht",
  },

  moderationmessage: {
    title: "Moderation",
    newMessage: "Dein Beitrag wurde aufgrund eines Verstoßes gegen unsere Richtlinien aus dem öffentlichen Feed entfernt.",
  },
},

////////////////////////////////////////////////////////////
//Profile
////////////////////////////////////////////////////////////

profile: {
  avatar: {
    change: "Ändern",
    help: "PNG/JPG • Max. 10 MB",
    clearSelection: "✖︎ Auswahl löschen",
    removePicture: "👻 Profilbild entfernen",
  },

  fields: {
    profilenameLabel: "Profilname (nicht änderbar)",
    profilenamePlaceholder: "Dein öffentlicher Name",
    locationLabel: "Mein Standort (optional)",
    locationPlaceholder: "Beliebig",
    bioLabel: "Was man über mich wissen sollte (optional)",
    bioPlaceholder: "Kurze Beschreibung oder etwas anderes",
  },

  actions: {
    saving: "Wird gespeichert…",
    save: "💾 Änderungen speichern",
  },

  messages: {
    updated: "✅ Profil aktualisiert!",
  },

  errors: {
    missingToken: "Authentifizierungstoken fehlt",
    fileTooLarge: "Datei ist zu groß (Worker MAX_UPLOAD_MB?)",
    updateFailed: "❌ Aktualisierung fehlgeschlagen",
    imageTooBig: "Bitte wähle ein Bild unter 10 MB",
    imageType: "Bitte wähle ein Bild aus",
  },
},

////////////////////////////////////////////////////////////
//Visitor Postings
////////////////////////////////////////////////////////////

visitorPostings: {
  header: {
    name: "Name",
    location: "Standort",
    about: "Über",
  },

  buttons: {
    presentation: "🎬 Präsentation",
  },

  avatar: {
    alt: "Profilbild",
  },

  loading: {
    profile: "Profil von {{name}} wird geladen…",
  },

  scrollHint: {
    viewPosts: "Scrolle nach unten, um die Beiträge von {{name}} anzusehen",
  },

  empty: {
    noPosts: "Noch keine Beiträge",
  },

  restricted: {
    name: "Benutzer",
    bio: "Die Beiträge dieses Benutzers sind ausgeblendet.",
  },
},

} as const;
  
  export default myProfile;
  